<template>
  <div class="app-page box-card">
    <div class="box-card-content">

      <!-- <div class="countrys">
        <div class="countrys-item" :class="[queryForm.account_market === item.id ? 'active' : '', ` item${item.id}`]"
          @click="onAccountMarket(item.id)" v-for="(item, key) in userInfo.national_markets" :key="key"></div>
      </div> -->
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="姓名/交易账号">
            <template slot="label">
              <I18Lang id="proxycust109" defaultText="姓名/交易账号" />
            </template>
            <el-input style="width:200px" :placeholder="$t('proxycust110')" v-model="queryForm.name"></el-input>
          </el-form-item>

          <el-form-item label="转账类型">
            <template slot="label">
              <I18Lang id="userstatement87" defaultText="转账类型" />
            </template>
            <el-select v-model="queryForm.transfer_type" :placeholder="$t('proxymoneymanage27')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in transferTypesText" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="转账时间">
            <template slot="label">
              <I18Lang id="proxymoneymanage21" defaultText="转账时间" />
            </template>
            <el-date-picker v-model="queryDate" type="daterange" @change="dateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>
          <el-table-column label="用户名">
            <template slot="header">
              <I18Lang id="proxymoneymanage15" defaultText="用户名" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.username }}
            </template>
          </el-table-column>
          <el-table-column label="交易账号">
            <template slot="header">
              <I18Lang id="proxymoneymanage45" defaultText="交易账号" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.trade_account_no }}
            </template>
          </el-table-column>
          <!--
          <el-table-column label="账号类型" prop="stream_no">
            <template slot="header">
              <I18Lang id="proxymoneymanage38" defaultText="账户类型" />
            </template>
            <template slot-scope="{row}">
              <span class="item-text">
                {{ row.trade_account_mode === 0 ? $t('user42') : $t('user45') }}
              </span>
            </template>
          </el-table-column>
          -->
          <el-table-column label="转账金额($)" prop="amount">
            <template slot="header">
              <I18Lang id="proxymoneymanage60" defaultText="转账金额($)" />
            </template>
          </el-table-column>
          <!--
          <el-table-column :label="`${$t('proxymoneymanage61', { n: currMarket })}`" prop="amount_local">
          </el-table-column>
          <el-table-column label="转账汇率" prop="exchange_rate">
            <template slot="header">
              <I18Lang id="userstatement68" defaultText="转账汇率" />
            </template>
          </el-table-column>
          -->
          <el-table-column label="转账类型">
            <template slot="header">
              <I18Lang id="userstatement76" defaultText="转账类型" />
            </template>
            <template slot-scope="scope">
              {{ transferTypesText[scope.row.transfer_type] }}
            </template>
          </el-table-column>
          <el-table-column label="转账时间" prop="create_time">
            <template slot="header">
              <I18Lang id="userstatement88" defaultText="转账类型" />
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="total, prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'

export default {
  name: 'record',
  data () {
    return {
      transferTypesText: {
        1: this.$t('userstatement78'), // 转入
        2: this.$t('userstatement79') // 转出
      },
      queryDate: '',
      queryForm: {
        username: '',
        transfer_type: '',
        page: 1,
        size: 10
      },
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.queryForm.account_market = +cookie.get('national_market')
      this.getRecord()
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/tradeTransferRecordList?${formateObjToParamStr(
          params
        )}`
      )
    },
    // onAccountMarket (i) {
    //   this.queryForm.account_market = i
    //   this.getRecord()
    // },
    getRecord () {
      this.$http.post('/api/agent/tradeTransferRecordList', this.queryForm).then(result => {
        this.tableData = result
      })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryForm.account_market = '3'
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
.countrys {
  display: flex;
  margin-top: 15px;

  .countrys-item {
    width: 40px;
    height: 40px;
    margin-right: 50px;
    border: 2px solid transparent;
    cursor: pointer;

    &.item3 {
      background: url('../../../assets/img/country/yd.png') no-repeat center / 100% 100%;
    }

    &.item2 {
      background: url('../../../assets/img/country/xg.png') no-repeat center / 100% 100%;
    }

    &.item1 {
      background: url('../../../assets/img/country/en.png') no-repeat center / 100% 100%;
    }

    &.item4 {
      background: url('../../../assets/img/country/jp.png') no-repeat center / 100% 100%;
    }

    &.active {
      border: 2px solid #00CCFF;
      border-radius: 50%;
    }
  }
}

.reset-query {
  margin-top: 15px;
}
</style>
